"use strict";

exports.__esModule = true;
exports.Select = void 0;

var React = _interopRequireWildcard(require("react"));

var _icons = require("@manifest-ui/icons");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _Select = require("./Select.styles");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/select/src/Select.tsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const components = {
  ClearIndicator: ({
    innerProps
  }) => React.createElement(_Select.StyledIndicatorContainer, _extends({
    className: "manifestui-select__indicator-container"
  }, innerProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 5
    }
  }), React.createElement(_icons.Clear, {
    className: "manifestui-select__clear-icon",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 7
    }
  })),
  Control: ({
    innerProps,
    innerRef,
    children,
    isDisabled,
    isFocused,
    selectProps
  }) => {
    const {
      startIcon
    } = selectProps;
    return React.createElement(_Select.StyledControl, _extends({
      className: "manifestui-select__control",
      "data-disabled": isDisabled ? '' : null,
      "data-focus": isFocused ? '' : null,
      ref: innerRef,
      "data-start-icon": startIcon
    }, innerProps, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 111,
        columnNumber: 7
      }
    }), children);
  },
  DropdownIndicator: ({
    innerProps,
    isDisabled
  }) => React.createElement(_Select.StyledIndicatorContainer, _extends({
    className: "manifestui-select__indicator-container",
    "data-disabled": isDisabled ? '' : undefined
  }, innerProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 5
    }
  }), React.createElement(_icons.ExpandMore, {
    className: "manifestui-select__expand-icon",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 7
    }
  })),
  IndicatorSeparator: null,
  IndicatorsContainer: ({
    children
  }) => React.createElement(_Select.StyledIndicatorsContainer, {
    className: "manifestui-select__indicators-container",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 5
    }
  }, children),
  Input: ({
    innerRef,
    isDisabled,
    isHidden,
    inputClassName,
    size,
    theme,
    ...other
  }) => React.createElement(_Select.StyledInput, _extends({
    className: "manifestui-select__input",
    disabled: isDisabled,
    ref: innerRef
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 5
    }
  })),
  MultiValue: ({
    children,
    innerProps,
    removeProps
  }) => React.createElement(_Select.StyledMultiValue, _extends({
    className: "manifestui-select__multi-value"
  }, innerProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 5
    }
  }), React.createElement(_Select.StyledMultiValueLabel, {
    className: "manifestui-select__multi-value-label",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 7
    }
  }, children), React.createElement(_Select.StyledMultiValueRemove, _extends({
    className: "manifestui-select__multi-value-remove",
    role: "button"
  }, removeProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 7
    }
  }), React.createElement(_icons.Clear, {
    className: "manifestui-select__clear-icon",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 9
    }
  }))),
  Menu: ({
    innerProps,
    innerRef,
    children
  }) => React.createElement(_Select.StyledMenu, _extends({
    className: "manifestui-select__menu",
    ref: innerRef
  }, innerProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 5
    }
  }), children),
  Option: ({
    innerProps,
    innerRef,
    children,
    isFocused,
    isSelected,
    isDisabled
  }) => React.createElement(_Select.StyledOption, _extends({
    className: "manifestui-select__option",
    "data-disabled": isDisabled ? '' : null,
    "data-focus": isFocused ? '' : null,
    "data-selected": isSelected ? '' : null,
    ref: innerRef
  }, innerProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 5
    }
  }), children),
  Placeholder: ({
    children,
    selectProps
  }) => {
    const {
      startIcon
    } = selectProps;
    return React.createElement(_Select.StyledPlaceholder, {
      className: "manifestui-select__placeholder",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 180,
        columnNumber: 7
      }
    }, startIcon && React.createElement(_Select.StyledInputIcon, {
      className: "manifestui-input-startIcon",
      "data-placement": "start",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 11
      }
    }, startIcon), children);
  },
  SingleValue: ({
    innerProps,
    children
  }) => React.createElement(_Select.StyledSingleValue, _extends({
    className: "manifestui-select__single-value"
  }, innerProps, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 191,
      columnNumber: 5
    }
  }), children),
  ValueContainer: ({
    children,
    isDisabled,
    selectProps,
    theme,
    ...other
  }) => {
    const {
      startIcon
    } = selectProps;
    return React.createElement(_Select.StyledValueContainer, _extends({
      className: "manifestui-select__value-container"
    }, other, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 198,
        columnNumber: 7
      }
    }), startIcon && React.createElement(_Select.StyledInputIcon, {
      className: "manifestui-input-startIcon",
      "data-placement": "start",
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 11
      }
    }, startIcon), children);
  }
};
const Select = React.forwardRef((props, ref) => {
  const {
    id,
    placeholder,
    isSearchable = false,
    startIcon,
    ...other
  } = props;
  return React.createElement(_Select.StyledSelect, {
    className: "manifestui-select",
    ref: ref,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 5
    }
  }, React.createElement(_reactSelect.default, _extends({
    id: id && `__${id}__`,
    components: components,
    inputId: id,
    isSearchable: isSearchable,
    placeholder: placeholder ?? '',
    startIcon: startIcon
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 7
    }
  })));
});
exports.Select = Select;
Select.displayName = 'Select';